import { render } from "./ToggleButton.vue?vue&type=template&id=12a396ea&scoped=true&ts=true&lang=pug"
import script from "./ToggleButton.vue?vue&type=script&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=12a396ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a396ea"]])

export default __exports__